import { SxProps } from '@mui/material'
import { FONT_WEIGHTS } from '@/styles'

export interface NavigationMenuStyles {
  container: SxProps
}

export const navigationMenuStyles: NavigationMenuStyles = {
  container: {
    width: 'auto',
    minWidth: 'auto',
    height: 575,
    padding: 2.5,
    ml: -2.5,
    borderRadius: 4,
    borderColor: 'border.secondary',
    borderWidth: 1,
    borderStyle: 'solid',
    backgroundColor: 'background.default',
    boxShadow:
      '0 12px 16px -4px rgba(10, 13, 18, 0.08), 0 4px 6px -2px rgba(10, 13, 18, 0.03), 0 2px 2px -1px rgba(10, 13, 18, 0.04);',
  },
}

interface NavigationMenuDetailsStyles {
  navigation: SxProps
  navigationFanatics: SxProps
  navigationItem: SxProps
  navigationText: SxProps
  navigationMenuDetailWrapper: SxProps
  itemList: SxProps
  columnHeaderName: SxProps
  itemContainer: SxProps
  selectedItem: SxProps
  childrenItemList: SxProps
  childrenItemContainer: SxProps
  childrenItemColorBar: SxProps
  itemName: SxProps
}

export const navigationMenuDetailsStyles: NavigationMenuDetailsStyles = {
  navigation: {
    display: { xs: 'none', lg: 'flex' },
    height: '100%',
    position: 'relative',
    flex: 1,
    justifyContent: 'center',
  },
  navigationFanatics: {
    mt: 1.2,
  },
  navigationItem: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: '100%',
    gap: 0.5,
    px: 1.25,
    color: 'pageTheme.secondaryColor',
  },
  navigationText: {
    typography: 'textMd',
    fontWeight: FONT_WEIGHTS.HEAVY,
  },
  navigationMenuDetailWrapper: {
    width: '100%',
    height: '100%',
    display: 'flex',
    justifyContent: 'center',
    gap: 2.5,
  },
  itemList: {
    width: 'auto',
    height: 'auto',
    maxHeight: '100%',
    padding: 1,
    display: 'flex',
    flexDirection: 'column',
    overflow: 'auto',
  },
  columnHeaderName: {
    typography: 'textSm',
    fontWeight: FONT_WEIGHTS.STRONG,
    textTransform: 'uppercase',
    color: 'brand.primary600',
    fontStyle: 'normal',
    mb: 1,
  },
  itemContainer: {
    display: 'flex',
    padding: 1,
    gap: 1.5,
    borderRadius: 2,
    textDecoration: 'none',
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: 'background.secondary',
    },
  },
  selectedItem: {
    backgroundColor: 'background.secondary',
  },
  childrenItemList: {
    flex: 1,
    maxHeight: '100%',
    overflowY: 'auto',
    padding: 1,
    backgroundColor: 'utils.gray50',
    borderRadius: 4, // 16px
    display: 'flex',
    flexDirection: 'column',
    width: 275,
  },
  childrenItemContainer: {
    display: 'flex',
    padding: 1,
    gap: 1.5,
    borderRadius: 2,
    cursor: 'pointer',
    textDecoration: 'none',
    '&:hover': {
      backgroundColor: 'background.default',
    },
  },
  childrenItemColorBar: {
    width: 5,
    height: 24,
    borderRadius: 1,
  },
  itemName: {
    typography: 'textMdSemibold',
    textTransform: 'capitalize',
    color: 'text.primary900',
  },
}
